import { render } from "./SocialAccountCallbackView.vue?vue&type=template&id=445e4a36&ts=true"
import script from "./SocialAccountCallbackView.vue?vue&type=script&lang=ts"
export * from "./SocialAccountCallbackView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__